import { loggerConfig } from './config/loggerConfig.js';
// Detect a real Node environment rather than a browser polyfill.
const isNode = typeof process !== 'undefined' && typeof process.versions?.node !== 'undefined';
// Skip Sentry initialisation in Jest test environment to avoid open handles
const isJest = isNode && typeof process.env['JEST_WORKER_ID'] !== 'undefined';
// Allow an explicit kill-switch so services without @sentry/node in their runtime image
// can silence the fallback warning without removing DSN values.
const isDisabled = isNode && (process.env['SENTRY_DISABLED'] ?? '').toLowerCase() === 'true';
let sentryModule;
let sentryModulePromise;
export function createNoopSentryModule() {
    /* eslint-disable @typescript-eslint/no-empty-function */
    return {
        init() { },
        flush: async () => { },
        withScope: (_callback) => {
            const dummyScope = {}; // Dummy scope object
            _callback(dummyScope);
        },
        captureException: () => { },
    };
    /* eslint-enable @typescript-eslint/no-empty-function */
}
async function getSentry() {
    if (sentryModule) {
        return sentryModule;
    }
    if (!sentryModulePromise) {
        sentryModulePromise = (async () => {
            try {
                if (isDisabled) {
                    const mod = createNoopSentryModule();
                    sentryModule = mod;
                    return mod;
                }
                const mod = isNode
                    ? await new Function('m', 'return import(m)')(['@sentry', 'node'].join('/'))
                    : await import('@sentry/browser');
                sentryModule = mod;
                return mod;
            }
            catch (error) {
                if (!isDisabled) {
                    console.warn('Failed to load Sentry module. Falling back to no-op stubs.', error);
                }
                const mod = createNoopSentryModule();
                sentryModule = mod;
                return mod;
            }
        })();
    }
    return sentryModulePromise;
}
if (!isJest && !isDisabled && loggerConfig.sentry.dsn) {
    void getSentry().then((Sentry) => {
        Sentry.init({
            dsn: loggerConfig.sentry.dsn,
            environment: loggerConfig.sentry.environment,
        });
    });
}
// Function to log errors to Sentry
export const logError = async (error, context = {}) => {
    if (isJest || isDisabled || !loggerConfig.sentry.dsn) {
        return;
    }
    const Sentry = await getSentry();
    Sentry.withScope((scope) => {
        scope.setExtras(context);
        Sentry.captureException(error);
    });
};
export const flushSentry = async () => {
    if (isJest || isDisabled || !loggerConfig.sentry.dsn) {
        return;
    }
    const Sentry = await getSentry();
    await Sentry.flush();
};
//# sourceMappingURL=sentry.js.map